export const READING_LEVELS = {
  he: ["easy", "medium", "hard"],
  en: ["starter", "basic", "advanced"],
} as const;
export type ReadingLevels = { he?: typeof READING_LEVELS.he[number]; en?: typeof READING_LEVELS.en[number] };
export function isReadingLevel(language: unknown, preset: unknown): boolean {
  return (language === "he" || language === "en") && typeof preset === "string"
    && (READING_LEVELS[language] as readonly string[]).includes(preset);
}
export function readReadingLevels(value: unknown): ReadingLevels {
  const levels = (value ?? {}) as ReadingLevels;
  return {
    ...(isReadingLevel("he", levels.he) ? { he: levels.he } : {}),
    ...(isReadingLevel("en", levels.en) ? { en: levels.en } : {}),
  };
}
